<template>
  
    <v-card>
      <v-flex xs12 class="mt-2 text-xs-center">
        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.checkbox)">
          Multiple
          <v-icon dark right>check_box</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.radiobox)">
          Radio
          <v-icon dark right>radio_button_checked</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.textbox)">
          Text
          <v-icon dark right>short_text</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.ratingbox)">
          Rating
          <v-icon dark right>star</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.sliderbox)">
          Slider
          <v-icon dark right>tune</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.datebox)">
          Date
          <v-icon dark right>date_range</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.timebox)">
          Time
          <v-icon dark right>av_timer</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.numberbox)">
          Number
          <v-icon dark right>filter_1</v-icon>
        </v-btn>

        <v-btn class="question-button" color="primary" dark @click="addQuestion(formTypes.photobox)">
          Photo
          <v-icon dark right>add_a_photo</v-icon>
        </v-btn>

      </v-flex>
    </v-card>

</template>

<script>

// @ is an alias to /src
export default {
  name: "questionTypes",
  components: {
  },
  methods: {
    addQuestion(type) {
    	// Create an ID for the new question
      const newQuestion = {
        qid : this.$uuid.v1(),
        type : type
      };
      // console.log("Adding", type);
      // Store the new question to form to Vuex
      this.$store.commit('addToForm', newQuestion);
    }
  }
};
</script>

<style scoped>
  .question-button {
    width: 130px;
  }
</style>